import { motion } from 'framer-motion';
import { Colors } from '../../themes/colors';
import { Text } from '../Text';
import { Box } from '../Box';
import { Center } from '../Center';

interface ITabProps {
  title: string;
  badge?: string | number;
  isActive: boolean;
  setActiveTab: () => void;
  textStyle?: React.CSSProperties;
  totalCount?: number;
  isNew?: boolean;
}

const borderColorVariants = {
  active: {
    borderColor: Colors.secondary_500,
  },
  inactive: {
    borderColor: Colors.white,
  },
};

const spanVariants = {
  active: {
    fontWeight: 700,
  },
  inactive: {
    fontWeight: 400,
  },
};

export const Tab = ({
  title,
  badge,
  isActive,
  setActiveTab,
  textStyle = {},
  totalCount,
  isNew = false,
}: ITabProps) => (
  <button
    key={isActive ? 'active' : 'inactive'}
    type="button"
    onClick={(e) => {
      e.stopPropagation();
      e.preventDefault();
      setActiveTab();
    }}
    style={{
      all: 'unset',
      cursor: 'pointer',
    }}
  >
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      }}
    >
      <motion.div
        initial="inactive"
        transition={{ duration: 0.3 }}
        animate={isActive ? 'active' : 'inactive'}
        variants={borderColorVariants}
        style={{
          paddingRight: 10,
          paddingLeft: 10,
          borderBottomWidth: 3,
          borderBottomStyle: 'solid',
          position: 'relative',
        }}
      >
        <motion.span
          initial="inactive"
          transition={{ duration: 0.1 }}
          animate={isActive ? 'active' : 'inactive'}
          variants={spanVariants}
          style={{
            fontFamily: 'Nunito',
            display: 'flex',
            alignItems: 'center',
            color: isActive ? Colors.neutral_600 : Colors.neutral_300,
            fontSize: 22,
            paddingBottom: 4,
            ...textStyle,
          }}
        >
          {title}
          {!!badge && (
            <span
              style={{
                position: 'absolute',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontFamily: 'Nunito',
                backgroundColor: Colors.error_500,
                color: Colors.white,
                fontSize: 11,
                fontWeight: 700,
                padding: 2,
                minWidth: 16,
                borderTopLeftRadius: 12,
                borderTopRightRadius: 12,
                borderBottomLeftRadius: 12,
                borderBottomRightRadius: 12,
                top: -4,
                right: -8,
              }}
            >
              {badge}
            </span>
          )}
        </motion.span>
      </motion.div>

      {totalCount != null && (
        <Box
          backgroundColor={isActive ? Colors.primary_500 : Colors.primary_100}
          borderRadius={3}
          paddingHorizontal={7}
          paddingVertical={2}
          marginBottom={5}
        >
          <Text color={isActive ? 'white' : 'primary_500'} fontSize={14} bold>
            {totalCount}
          </Text>
        </Box>
      )}

      {isNew && (
        <Center
          backgroundColor={Colors.secondary_500}
          width={48}
          height={20}
          borderRadius={3}
          marginBottom={8}
          marginLeft={8}
        >
          <Text bold fontSize={12} color="white">
            NEW
          </Text>
        </Center>
      )}
    </div>
  </button>
);

Tab.displayName = 'Tab';
